import { render, staticRenderFns } from "./order-insurance-component.vue?vue&type=template&id=67cdc0a5"
import script from "./order-insurance-component.vue?vue&type=script&lang=js"
export * from "./order-insurance-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports